import { useTranslation } from 'react-i18next';

import { Box, Text } from '@olist/united';

const UnqualifiedMessage = () => {
  const { t } = useTranslation();

  return (
    <Box lineHeight="120%" fontSize={1} mb={8}>
      <Text color="textLight">
        {t`Understand below what you need to sell with olist and how we can help you`}
      </Text>
    </Box>
  );
};

export default UnqualifiedMessage;
